import { reactive } from 'vue'

export const loading = reactive({
  value: false,
  pending: 0,
  start () {
    this.pending += 1
    this.value = true
  },
  stop () {
    this.pending = Math.max(0, this.pending - 1)
    this.value = this.pending > 0
  }
})
